import React from 'react';
import {
  reduxForm, InjectedFormProps, Field,
} from 'redux-form';
import { Grid } from '@material-ui/core';
import {
  required, minLength5, maxLength150, urlValidator,
} from '../../helpers/validate-forms';
import Input from '../Input/Input';
import Button from '../Button/Button';
import CenterLine from '../Center/CenterInLine';
import ContainerForm from '../ContainerForm/ContainerForm';
import FormRedux from '../FormRedux/FormRedux';
import ContainerInputs from '../ContainerInputs/ContainerInputs';

const TopicForm: React.FC<InjectedFormProps> = ( props ) => {
  const {
    handleSubmit, submitting,
  } = props;

  return (
    <ContainerForm>
      <FormRedux
        onSubmit={handleSubmit}
      >
        <ContainerInputs>
          <Grid item xs={12} sm={6}>
            <Field
              name="name"
              type="text"
              component={Input}
              placeholder="Nombre del tema"
              validate={[required, minLength5, maxLength150]}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field
              name="url"
              type="text"
              component={Input}
              placeholder="Url del tema"
              validate={[required, minLength5, urlValidator]}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <CenterLine>
              <Button block type="submit" disabled={submitting}>
                Enviar
              </Button>
            </CenterLine>
          </Grid>
        </ContainerInputs>
      </FormRedux>
    </ContainerForm>
  );
};

export default reduxForm({
  form: 'topic',
  enableReinitialize: true,
})( TopicForm );
